export default "__VITE_ASSET__B4mTTO1a__"